import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  newReporte:[],
};
export const mutations = {
     SAVE_REPORTE({ context }, data) {
        state.newReporte = Object.assign({}, data);
    },
};
export const actions = {
    SAVE_REPORTE({ commit }, data) { //axios, mandar parametros para post
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.postJSON(data)
            .then(response => {
                commit("SAVE_REPORTE", response);//mandar a mutations
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit("SET_LOADING", false);
          });
        });
    },
};

export const getters = {
    newReporte: state => state.newReporte
}